<template>
  <div class="index" v-wechat-title="title">
    <el-backtop></el-backtop>
      <div class="index_head">
        <div class="head_title">
          <div class="head_title_left">
            <img src="@/assets/img/play.png" />
            <div class="title">课程集市</div>
            <div>提升自身专业能力</div>
          </div>
          <div class="head_title_right">
            <el-input placeholder="搜索感兴趣的课程吧～" @change="toggleValue()" v-model="listQuery.value" class="input-with-select">
              <el-button slot="append" icon="el-icon-search" @click="toggleValue()"></el-button>
            </el-input>
          </div>

        </div>
        <div class="head_direction">
          <div class="title">方向：</div>
          <div class="dir_right">
<!--            <div class="r_a" @click="togglePro(null)" :class="[listQuery.type==null?'active':'']">全部</div>-->
            <div class="r_b">
              <div class="name" @click="togglePro(item.type)" :class="[listQuery.type==item.type?'active':'']" v-for="(item,index) in direction" :key="index">{{item.title}}</div>
            </div>
          </div>
        </div>
        <div class="head_jobs">
          <div class="title">岗位：</div>
          <div class="dir_right">
            <div class="r_b" :class="[is_show&&jobslist.length>30 ?'r_b_z':'']">
              <div class="name" @click="toggleJobs(item.id)" :class="[listQuery.jobs_id==item.id?'active':'']" v-for="(item,index) in jobslist" :key="index">{{item.title}}</div>
            </div>
          </div>
        </div>
        <div class="head_unfold" v-if="jobslist.length>30 && listQuery.type==null">
          <div v-if="is_show" @click="toggleShow">展开更多</div>
          <div v-else @click="toggleShow">收起更多</div>
        </div>
      </div>
      <div class="index_centent">
<!--        <el-tag type="danger" style="margin: 10px 0">-->
<!--          提示：您当前的岗位为《{{user.job}}》，当前岗位要求学时《{{user.studyHours}}》个，请选择对应岗位课程-->
<!--        </el-tag>-->
        <div class="conditions">
          <div class="name" @click="toggleConditions(item.title)" :class="[listQuery.conditions==item.title?'active':'']" v-for="(item,index) in conditionslist" :key="index">{{item.title}}</div>
        </div>
        <div class="centent_list" v-loading="loading" element-loading-text="拼命加载中">
          <template v-if="courselist.length>0">
            <newcourse :list="courselist"></newcourse>
          </template>
          <template v-else>
            <div class="centent_list_no">
              <img src="https://zz-website.oss-cn-beijing.aliyuncs.com/images/empty-icon.png" />
              <div class="name">暂无此类课程~</div>
            </div>
          </template>
        </div>

      </div>
    <div class="apply_page">
      <el-pagination
              v-show="total>0"
              :current-page="listQuery.page"
              :page-sizes="[15,30,60,100]"
              :page-size="listQuery.limit"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      />
    </div>

    <!-- 待选区   -->
    <div class="index_waiting">
<!--      <waiting></waiting>-->
    </div>

  </div>
</template>

<script>
    import newcourse from '@/components/newcourse/Index'
    import  waiting from '@/components/Waiting/Index'
    import {GetItemByData} from '@/api/new/category'
    import {GetCourseItemByData} from '@/api/new/course'
    import {mapGetters} from "vuex";
    export default {
        name: "list",
        components:{
            newcourse,
            waiting
        },
        computed:{
            ...mapGetters(['userinfo','inst_id'])
        },
        data(){
            return{
                is_show:true,
                title:"选课学习",
                loading:false,
                courselist:[],
                // courselist:[
                //     {
                //         id:11,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:5,//课时
                //         num:28,
                //         title:"用来凑课时",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/5fd18a950924d88505400304.png",
                //         desc:"SpringBoot 2.x 实战仿B站高性能后端项目"
                //     },
                //     {
                //         id:122,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:30,//课时
                //         num:28,
                //         title:"SpringBoot 2.x 实战仿B站高性能后端项目",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/5fd18a950924d88505400304.png",
                //         desc:"SpringBoot 2.x 实战仿B站高性能后端项目"
                //     },
                //     {
                //         id:89,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:39,//课时
                //         num:68,
                //         title:"基于React + Redux/Mobx搞定大型复杂项目的状态管理",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/609b4519097a76c805400304.png",
                //         desc:"基于React + Redux/Mobx搞定大型复杂项目的状态管理"
                //     },
                //     {
                //         id:45,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:30,//课时
                //         num:28,
                //         title:"WebRTC源码级深度解析，进阶大厂高级音视频开发者",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/60223b8609a8ba1705400304.png",
                //         desc:"WebRTC源码级深度解析，进阶大厂高级音视频开发者"
                //     },
                //     {
                //         id:68,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:12,//课时
                //         num:218,
                //         title:"WebRTC源码级深度解析，进阶大厂高级音视频开发者",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/603627fd09f5c40f05400304.png",
                //         desc:"WebRTC源码级深度解析，进阶大厂高级音视频开发者"
                //     },
                //     {
                //         id:67,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:56,//课时
                //         num:668,
                //         title:"Vue3 从入门到实战 进阶式掌握完整知识体系",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/60497cca092fcd4805400304.png",
                //         desc:"Vue3 从入门到实战 进阶式掌握完整知识体系"
                //     },
                //     {
                //         id:27,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:35,//课时
                //         num:218,
                //         title:"WebRTC源码级深度解析，进阶大厂高级音视频开发者",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/603627fd09f5c40f05400304.png",
                //         desc:"WebRTC源码级深度解析，进阶大厂高级音视频开发者"
                //     },
                //     {
                //         id:147,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:40,//课时
                //         num:668,
                //         title:"Vue3 从入门到实战 进阶式掌握完整知识体系Vue3 从入门到实战 进阶式掌握完整知识体系",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/60497cca092fcd4805400304.png",
                //         desc:"Vue3 从入门到实战 进阶式掌握完整知识体系"
                //     },
                //     {
                //         id:162,
                //         category:{
                //             title:"现场专业人员"
                //         },
                //         studyHours:15,//课时
                //         num:668,
                //         title:"Vue3 从入门到实战 进阶式掌握完整知识体系",
                //         images_url:"https://publicdownload1.oss-cn-shenzhen.aliyuncs.com/imgaes/20210818/60497cca092fcd4805400304.png",
                //         desc:"Vue3 从入门到实战 进阶式掌握完整知识体系"
                //     }
                // ],
                total:null,
                listQuery:{
                    page: 1,
                    limit: 15,
                    value:'',
                    type:1,
                    conditions:null,//条件
                    jobs_id:null,//岗位
                },
                direction:[
                    {
                        id:1,
                        title:"现场专业人员",
                        type:1,
                    },
                    // {
                    //     id:2,
                    //     title:"特殊工种",
                    //     type:2,
                    // },
                    // {
                    //     id:3,
                    //     title:"普通工种",
                    //     type:3,
                    // },
                    // {
                    //     id:4,
                    //     title:"三类人员",
                    //     type:4,
                    // }
                ],
                jobslist:[],
                conditionslist:[
                    {id:1, title:"最新"},
                    {id:2, title:"销量"},
                    {id:3, title:"推荐"},
                ],
                user:{}
            }
        },
        mounted() {
            this.user = JSON.parse(this.userinfo)
        },
        created() {
            this.getCategory()
            this.fetchList()
        },
        methods:{
            toggleShow(){
                this.is_show = !this.is_show
            },
            getCategory(){
                GetItemByData(this.listQuery.type).then(res=>{
                    if(res.code==20000){
                        let list = res.data
                        let temp = {
                            id:null, title:'不限'
                        }
                        list.unshift(temp);
                        this.jobslist = list
                    }
                })
            },
            toggleValue(){
                this.listQuery.page = 1
                this.listQuery.limit = 15
                this.fetchList()
            },
            togglePro(type){
                let t = this.listQuery.type
                if(t==type){
                    return
                }
                this.listQuery.page = 1
                this.listQuery.limit = 15
                this.listQuery.type = type
                this.getCategory()
                this.fetchList()
            },
            toggleJobs(id){
                let t = this.listQuery.jobs_id
                if(t==id){
                    return
                }
                this.listQuery.page = 1
                this.listQuery.limit = 15
                this.listQuery.jobs_id = id
                this.fetchList()
            },
            toggleConditions(title){
                let t = this.listQuery.conditions
                if(t==title){
                    return
                }
                this.listQuery.page = 1
                this.listQuery.limit = 15
                this.listQuery.conditions = title
                this.fetchList()
            },
            fetchList(){
                this.loading = true
                let listQuery = this.listQuery
                GetCourseItemByData(listQuery).then(res=>{
                    if(res.code==20000){
                        this.loading = false
                        this.courselist = res.data.data
                        this.total = res.data.total
                    }
                    this.loading = false
                })
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.fetchList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.fetchList()
            },
        }
    }
</script>

<style lang="scss" scoped>
  .index{
    margin-top: 80px;
  }
  .centent_list_no{
    min-height: 400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
      margin: 0 auto;
      width: 120px;
      height: 110px;
    }
    .name{
      margin-top: 20px;
      color: #999;
    }
  }
  .index_head{
    padding: 20px 0;
    min-height: 100px;
    background-color: #f0f2f5;
    img{
      width: 45px;
      height: 45px;
    }
    .head_title{
      width: 1200px;
      margin: 0 auto 30px;
      font-size: 12px;
      color: #909399;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      .head_title_left{
        display: flex;
        flex-direction: row;
        align-items: center;
        .title{
          color: #1a1a1a;
          font-size: 25px;
          margin: 0 10px;
          font-weight: bold;
        }
      }
      .head_title_right{
        .input-with-select{
          width: 400px;
        }
      }
    }
    .head_direction{
      width: 1200px;
      margin: 10px auto 25px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .title{
        color: #07111b;
        line-height: 32px;
        font-weight: 700;
        margin-right: 10px;
        font-size: 14px;
      }
      .dir_right{
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        color: #1c1f21;
        .r_a{
          cursor: pointer;
          padding: 6px 20px;
          margin-right: 15px;
        }
        .r_a.active{
          background-color: #efe6e0;
          color: #e98e46;
          border-radius: 5px;
          font-weight: bold;
        }
        .r_b{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-right: 15px;
          .name{
            padding: 6px 15px;
            cursor: pointer;
          }
          .name.active{
            background-color: #efe6e0;
            color: #e98e46;
            border-radius: 5px;
            font-weight: bold;
          }
        }
      }
    }
    .head_jobs{
      width: 1200px;
      margin: 10px auto 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
      .title{
        color: #07111b;
        line-height: 32px;
        font-weight: 700;
        margin-right: 10px;
        font-size: 14px;
      }
      .dir_right{
        width: 1100px;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
        color: #1c1f21;
        .r_b{
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          margin-right: 15px;
          .name{
            padding: 6px 20px;
            cursor: pointer;
            margin-top: 3px;
          }
          .name.active{
            background-color: #efe6e0;
            color: #e98e46;
            border-radius: 5px;
            font-weight: bold;
          }
        }
        .r_b.r_b_z{
          height: 100px;
          overflow: hidden;
        }
      }
    }
    .head_unfold{
      color: #3ab06f;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
    }
  }
.index_centent{
  margin: 20px auto;
  width: 1200px;
  .conditions{
    display: flex;
    flex-direction: row;
    align-items: center;
    .name{
      font-size: 12px;
      color: #333;
      padding: 5px 10px;
      cursor: pointer;
      margin-right: 15px;
    }
    .name.active{
      background-color: #4a5258;
      color: #fff;
      border-radius: 10px;
    }
  }
}
  .apply_page{
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 1200px;
    margin: 30px auto 0;
    padding-bottom: 30px;
  }
  .index_waiting{
    position: fixed;
    right: 80px;
    bottom: 30%;
    z-index: 20;
  }
</style>